import {configureStore} from '@reduxjs/toolkit';
import {configApi, openIdConnectBaseApi, dvzaSupportConsoleServiceApi} from '../api';
import {combineReducers} from 'redux';
import {appSlice} from './slices/appSlice';
import {searchFormSlice} from 'redux/slices/searchFormSlice';
import {searchResultsSlice} from './slices/searchResultsSlice';
import {appHeaderSlice} from './slices/appHeaderSlice';
import {similarResourceSearchSlice} from './slices/similarResourceSearchSlice';

const rootReducer = combineReducers({
  [configApi.reducerPath]: configApi.reducer,
  [dvzaSupportConsoleServiceApi.reducerPath]: dvzaSupportConsoleServiceApi.reducer,
  [openIdConnectBaseApi.reducerPath]: openIdConnectBaseApi.reducer,
  app: appSlice.reducer,
  searchForm: searchFormSlice.reducer,
  searchResults: searchResultsSlice.reducer,
  appHeader: appHeaderSlice.reducer,
  similarResourceSearch: similarResourceSearchSlice.reducer
});

export const setupStore = (preloadedState) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,

    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({serializableCheck: false, immutableCheck: false}).concat(
        configApi.middleware,
        dvzaSupportConsoleServiceApi.middleware,
        openIdConnectBaseApi.middleware
      )
  });
};
